import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
	name: 'longNumber',
})
export class LongNumber implements PipeTransform {
	constructor(private decimalPipe: DecimalPipe) {}

	public transform(value: number, digitsInfo = '0.0-2'): string {
		if (!Number.isFinite(value)) {
			return '0';
		}
		return this.decimalPipe.transform(value, digitsInfo);
	}
}
